import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import envConfig from '../../config';
import {
  fetchNotifications,
  fetchUnseenCount,
  updateAllNotifications,
  updateNotification,
} from '../routines/notificationRoutines';
import { request } from '../../common/util/RestClient';

export function* fetchNotificationSaga({ payload }) {
  try {
    const categoryParam = payload.category
      ? `&category=${payload.category}`
      : '';
    const lastIdParam = payload.lastId ? `&lastId=${payload.lastId}` : '';
    const unseenOnlyParam = payload.unseenOnly
      ? `&unseenOnly=${payload.unseenOnly}`
      : '';
    const URL = `${envConfig.APIG_URL}notification/notification?mode=1&size=15${categoryParam}${lastIdParam}${unseenOnlyParam}`;
    const response = yield call(request, URL);
    yield put(
      fetchNotifications.success({
        data: response.data,
        category: payload.category,
        unseenOnly: payload.unseenOnly,
        lastId: payload.lastId,
      })
    );
    yield put(fetchUnseenCount.trigger());
  } catch (error) {
    yield put(fetchNotifications.failure({ error }));
  } finally {
    yield put(fetchNotifications.fulfill());
  }
}

export function* fetchUnseenCountSaga() {
  try {
    const URL = `${envConfig.APIG_URL}notification/notification/unseen?mode=1`;
    const response = yield call(request, URL);
    yield put(fetchUnseenCount.success({ data: response.data }));
  } catch (error) {
    yield put(fetchUnseenCount.failure({ error }));
  } finally {
    yield put(fetchUnseenCount.fulfill());
  }
}

export function* updateNotificationSaga(action) {
  try {
    const { data, category, unseenOnly } = action.payload;
    const URL = `${envConfig.APIG_URL}notification/notification/${data.id}`;
    const config = {
      method: 'PATCH',
      payload: data,
    };
    const response = yield call(request, URL, config);

    if (response) {
      yield put(updateNotification.success({ category, unseenOnly, data }));
      yield put(fetchUnseenCount.trigger());
    }
  } catch (error) {
    yield put(updateNotification.failure({ error }));
  } finally {
    yield put(updateNotification.fulfill());
  }
}

export function* updateAllNotificationsSaga(action) {
  try {
    const { data, category, unseenOnly } = action.payload;
    const categoryParam = category ? `?category=${category}` : '';
    const URL = `${envConfig.APIG_URL}notification/notification/all${categoryParam}`;
    const config = {
      method: 'PATCH',
      payload: data,
    };
    const response = yield call(request, URL, config);
    if (response) {
      yield put(updateAllNotifications.success());

      yield put(fetchUnseenCount.trigger());
      yield put(fetchNotifications.trigger({ category, unseenOnly }));
    }
  } catch (error) {
    yield put(updateAllNotifications.failure({ error }));
  } finally {
    yield put(updateAllNotifications.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchNotifications.TRIGGER, fetchNotificationSaga),
    takeLatest(fetchUnseenCount.TRIGGER, fetchUnseenCountSaga),
    takeEvery(updateNotification.TRIGGER, updateNotificationSaga),
    takeEvery(updateAllNotifications.TRIGGER, updateAllNotificationsSaga),
  ]);
}
